import SvgIcon, { type SvgIconProps } from "@mui/material/SvgIcon";

import { ReactComponent as DecimalSvg } from "@/svgs/decimal.svg?react";

export default function DecimalIcon(props: SvgIconProps) {
	return <SvgIcon {...props} component={DecimalSvg} inheritViewBox />;
}
